import { createSlice } from '@reduxjs/toolkit';
import Moment from 'moment';

export type DateSelectionRange = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7;

export type DateRange = {
  start: string, end: string, selectedRange?: DateSelectionRange, lastPoll?: number,
};

type Action = { payload: DateRange };

const initialState: DateRange = {
  start: Moment().subtract(6, 'days').startOf('day').toDate()
    .toISOString(),
  end: Moment().endOf('day').toDate().toISOString(),
  selectedRange: 1,
  lastPoll: undefined,
};

const dateRangeSlice = createSlice({
  name: 'dateRange',
  initialState,
  reducers: {
    updateDateRange(state: DateRange, action: Action) {
      state.start = action.payload.start;
      state.end = action.payload.end;
      state.selectedRange = action.payload.selectedRange;
    },
    updateLastPoll(state: DateRange, action: { payload: number }) {
      state.lastPoll = action.payload;
    },
  },
});

export const isLiveMode = (state: DateRange) => state.selectedRange === 7;

export const { updateDateRange, updateLastPoll } = dateRangeSlice.actions;

export default dateRangeSlice.reducer;
